import OrganizationService from "@/services/OrganizationService.js";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        errors: null,
        branchDetails: null
    },
    mutations: {
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setErrors(state, payload) {
            state.errors = payload;
        },
        setBranchDetails(state, payload) {
            state.branchDetails = payload;
        }
    },
    actions: {
        async getBranchDetails({ commit }, request) {
            commit("setIsLoading", true);

            try {
              if (request.header.Authorization) {
                commit("setBranchDetails",
                    await OrganizationService.getBranchDetails(request)
                );
              } else {
                commit("setBranchDetails",
                    await OrganizationService.getPublicBranchDetails(request)
                );
              }
                
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setIsLoading", false);
            }
        }
    }
};
